import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { TransactionPeriod } from 'global/Securities/types/api/history';
import { Select } from '../styled';
import { PERIOD_SELECTIONS } from './constants';

interface Props {
  popUpId: string;
  period: TransactionPeriod;
  onChange(selectedPeriod: TransactionPeriod): void;
}

export default function PeriodSelection({ popUpId, period, onChange }: Props) {
  return (
    <>
      <Select
        // @ts-expect-error
        height="28px"
        defaultValue={period}
        value={period}
        onChange={onChange}
        getPopupContainer={() => document.getElementById(popUpId)}
      >
        {PERIOD_SELECTIONS.map(({ label, value }) => (
          <Select.Option key={value} value={value}>
            <Text
              color={period === value ? color.primary : color.nightRider}
              family={period === value ? 'bold' : 'regular'}
              as="span"
              className={period === value ? 'select-label' : ''}
            >
              {label}
            </Text>
          </Select.Option>
        ))}
      </Select>
    </>
  );
}
